import {
  Autocomplete,
  Box,
  FormControl,
  MenuItem,
  Select,
  TextField,
} from '@mui/material'
import { useEffect, useState } from 'react'

import { patientObj } from '../../providers/PatientChartPage/PatientChartPage.provider'
import {
  ProviderSchedulingLink,
  useProviders,
} from '../../providers/ProvidersProvider/ProvidersProvider.provider'
import { themeColors } from '../../theme'

export const ScheduleAppointment = ({
  activeChartPatient,
}: {
  activeChartPatient: patientObj
}) => {
  const [selectedProvider, setSelectedProvider] = useState<
    ProviderSchedulingLink | undefined
  >(undefined)

  const { allSchedulingLinks, getAllSchedulingLinks } = useProviders()

  useEffect(() => {
    getAllSchedulingLinks()
  }, [])

  const [searchKeyword, setSearchKeyword] = useState<string>('')

  const [selectedValue, setSelectedValue] = useState('')

  const handleAppointmentSelect = (value: string) => {
    if (value === 'bac-mum') {
      window.open(
        `https://app.greminders.com/t/7768c12a/medbacvisit?first_name=${activeChartPatient?.firstName}&last_name=${activeChartPatient?.lastName}&email=${activeChartPatient?.emailAddress}&phone=${activeChartPatient?.phoneNumber}`
      )
    } else {
      const link = selectedProvider?.gRemindersEventTypeLinks.find(
        (et: any) => et.id === value
      )

      if (link) {
        window.open(
          `${link.scheduleLink}?first_name=${activeChartPatient?.firstName}&last_name=${activeChartPatient?.lastName}&email=${activeChartPatient?.emailAddress}&phone=${activeChartPatient?.phoneNumber}`
        )
      }
    }
    setSelectedValue('')
  }

  return (
    <>
      <Box
        sx={{
          width: '240px',
          margin: '12px 0px',
          '& .MuiOutlinedInput-root': {
            color: 'white',

            '& fieldset': {
              borderColor: themeColors.gray10,
            },
            '&:hover fieldset': {
              borderColor: themeColors.gray10,
            },
            '&.Mui-focused fieldset': {
              borderColor: themeColors.gray10,
            },
          },
          '& .MuiInputLabel-root': {
            color: themeColors.gray10,
            '&.Mui-focused': {
              color: themeColors.gray10,
            },
          },
          '& .MuiSelect-icon': {
            color: themeColors.gray10,
          },
        }}
      >
        <Autocomplete
          options={allSchedulingLinks || []}
          sx={{ width: 'auto' }}
          getOptionLabel={(option: any) => option.providerName || ''}
          onChange={(_, data: any) => {
            if (data) {
              setSelectedProvider(data)
              setSearchKeyword(data.providerName || '')
            } else {
              setSelectedProvider(undefined)
              setSearchKeyword('')
            }
          }}
          inputValue={searchKeyword}
          onInputChange={(_, newInputValue) => {
            setSearchKeyword(newInputValue)
          }}
          renderInput={(params: any) => (
            <TextField
              {...params}
              size='small'
              variant='outlined'
              id='SearchByField'
              placeholder='Search or select a provider...'
              sx={{
                '& .MuiInputBase-input': {
                  fontSize: '16px',
                },
              }}
            />
          )}
        />
      </Box>
      <FormControl
        fullWidth
        sx={{
          width: '240px',
          '& .MuiOutlinedInput-root': {
            color: 'white',
            '& fieldset': {
              borderColor: themeColors.gray10,
            },
            '&:hover fieldset': {
              borderColor: themeColors.gray10,
            },
            '&.Mui-focused fieldset': {
              borderColor: themeColors.gray10,
            },
          },
          '& .MuiSelect-icon': {
            color: themeColors.gray10,
          },
        }}
      >
        <Select
          size='small'
          value={selectedValue}
          onChange={(e) => handleAppointmentSelect(e.target.value)}
          displayEmpty
          renderValue={(selected) => {
            if (!selected) {
              return (
                <div
                  style={{
                    textAlign: 'left',
                    color: '#9e9e9eb9',
                    fontSize: '.95rem',
                  }}
                >
                  Select Appointment Type
                </div>
              )
            }
            if (selected === 'bac-mum') {
              return 'Schedule MUM/BAC Visit'
            }
            const selectedLink =
              selectedProvider?.gRemindersEventTypeLinks.find(
                (link: any) => link.id === selected
              )
            return selectedLink?.eventTypeName || selected
          }}
        >
          <MenuItem value='bac-mum'>Schedule MUM/BAC Visit</MenuItem>

          {selectedProvider?.gRemindersEventTypeLinks.map((link: any) => {
            if (link.id) {
              return (
                <MenuItem key={link.id} value={link.id}>
                  {link.eventTypeName}
                </MenuItem>
              )
            } else return null
          })}
        </Select>
      </FormControl>
    </>
  )
}
